import { MsgType } from '@lib/sys-msg'
import ChatRow from './msgs/chat'
import SysRow from './msgs/sys'

export default function MsgRow({ data }) {
  if (data.type === MsgType.message) {
    return <ChatRow data={data.data} />
  }

  if (data.type === MsgType.system) {
    return <SysRow data={data.data} />
  }
}
